const ErrorCode = {
  IncorrectCredentials: "P1002",
  IncorrectProfileType: "P1026",
  StationPriceToolNotFound: "S1000",
  StationNotFound: "S1002",
  StationNotFoundv1: "S1001",
  StationHasNoDepot: "S1007",
  ProductHasExistingTransaction: "P10003",
  ProductHasExistingDeliveryLogs: "P10004",
};

export default ErrorCode;
